import React, { useState } from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEOComponent from "../components/seo"
import marked from "marked"
import placeholder from "../images/place-holder.webp"
import ArticleLeft from "../components/articleList/articleListItem"
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { GatsbyImage, getSrc } from "gatsby-plugin-image"
import Swiper from "react-id-swiper"
import { Navigation, Pagination } from "swiper/dist/js/swiper.esm"
import "swiper/dist/css/swiper.css"
import "../sass/pages/our-team.scss"

const BioTemplate = ({ pageContext, data }) => {
  const title = pageContext.title
  const bio = data.sanityPerson
  const posts = data.allSanityPost.edges.map((t) => t.node)
  const [currentActiveTab, setCurrentActiveTab] = useState(0)
  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab)
  }

  return (
    <Layout>
      <SEOComponent
        title={bio.metaTitle}
        description={bio.metaDesc}
        keyword={bio.metaKeyword}
      />
      <div className="bio-header-wrapper">
        <div className="container">
          <div className="bio-header">
            <div className="row justify-content-between">
              <div className="col-md-8 order-2 order-md-1">
                <div className="bio-header-text h-100 d-flex flex-column gap-5">
                  <h1 className="text-black m-0">{title}</h1>
                  <span className="d-block m-0 h4 font-weight-bold">
                    {bio.position}
                  </span>
                  {bio.languages.length > 1 ? (
                    <div className="bio-language">
                      <ul className="list-styled list-inline">
                        {bio.languages.map((e, b) => (
                          <li className="list-inline-item">
                            <span>{e}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null}
                  {bio && bio?.linkedinLink ? (
                    <a
                      href={bio && bio?.linkedinLink}
                      target="_blank"
                      rel="noreferrer"
                      style={{ zIndex: 1, width: "fit-content" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={32}
                        height={32}
                        viewBox="0 0 176 176"
                        style={{
                          enableBackground: "new 0 0 512 512",
                        }}
                        xmlSpace="preserve"
                      >
                        <g
                          xmlns="http://www.w3.org/2000/svg"
                          data-name="Layer 2"
                        >
                          <rect
                            fill="#0077b5"
                            height={176}
                            rx={24}
                            width={176}
                            data-original="#0077b5"
                          />
                          <g fill="#fff">
                            <path
                              d="M63.4 48a15 15 0 1 1-15-15 15 15 0 0 1 15 15zM60 73v66.27a3.71 3.71 0 0 1-3.71 3.73H40.48a3.71 3.71 0 0 1-3.72-3.72V73a3.72 3.72 0 0 1 3.72-3.72h15.81A3.72 3.72 0 0 1 60 73zM142.64 107.5v32.08a3.41 3.41 0 0 1-3.42 3.42h-17a3.41 3.41 0 0 1-3.42-3.42v-31.09c0-4.64 1.36-20.32-12.13-20.32-10.45 0-12.58 10.73-13 15.55v35.86A3.42 3.42 0 0 1 90.3 143H73.88a3.41 3.41 0 0 1-3.41-3.42V72.71a3.41 3.41 0 0 1 3.41-3.42H90.3a3.42 3.42 0 0 1 3.42 3.42v5.78c3.88-5.82 9.63-10.31 21.9-10.31 27.18 0 27.02 25.38 27.02 39.32z"
                              data-original="#ffffff"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                  ) : null}
                </div>
              </div>
              <div className="col-md-4 col-lg-3 px-4 mb-3 px-md-0 mb-md-0 order-1 order-md-2">
                <div
                  className="bio-header-img"
                  style={{
                    backgroundImage: `url(${
                      getSrc(bio?.headerBackground?.asset?.gatsbyImageData)
                        ? getSrc(bio?.headerBackground?.asset?.gatsbyImageData)
                        : getSrc(bio?.image?.asset?.gatsbyImageData)
                        ? getSrc(bio?.image?.asset?.gatsbyImageData)
                        : placeholder
                    } )`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center d-flex flex-wrap justify-content-center gap-2 mt-5">
        {bio.name === "Arnaldo Brasil" ? (
          <a
            href={
              (bio && bio.appointmentLink2) ||
              "https://www.baystreetcapitalholdings.com/loan-application/"
            }
            target="_blank"
            rel="noreferrer"
            className="solid-btn-homepage"
          >
            Complete Loan Application
          </a>
        ) : (
          <>
            <a
              href={
                (bio && bio.appointmentLink) ||
                "https://baystreet.continual.ly/"
              }
              target="_blank"
              rel="noreferrer"
              className="solid-btn-homepage"
            >
              Schedule an Appointment with {bio.nickname}
            </a>
          </>
        )}
      </div>

      <div style={{ paddingTop: "5rem", paddingBottom: "5rem" }}>
        <div className="container">
          <div className="d-flex flex-column gap-5">
            {bio.biography ? (
              <div className="pb-5 bio-biography-wrapper">
                <h2 className="small-section-heading mb-5">Background</h2>
                <div className="row justify-content-center">
                  {bio.biography.length > 1 ? (
                    <div className="col-lg-10">
                      <Nav tabs className="list-unstyled">
                        {bio.biography &&
                          bio.biography.map((item, index) => (
                            <NavItem key={index}>
                              <NavLink
                                className={classnames({
                                  active: currentActiveTab === index,
                                })}
                                onClick={() => {
                                  toggle(index)
                                }}
                              >
                                {item.language}
                              </NavLink>
                            </NavItem>
                          ))}
                      </Nav>
                      <TabContent activeTab={currentActiveTab}>
                        {bio.biography &&
                          bio.biography.map((item, index) => (
                            <TabPane key={index} tabId={index}>
                              {item.body && (
                                <div className="bio-biography mt-4">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: marked(item.body),
                                    }}
                                  ></div>
                                </div>
                              )}
                            </TabPane>
                          ))}
                      </TabContent>
                    </div>
                  ) : (
                    <div className="col-lg-10">
                      {bio.biography &&
                        bio.biography.map((item, index) => (
                          <TabPane key={index} tabId={index}>
                            {item.body && (
                              <div className="bio-biography mt-4">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: marked(item.body),
                                  }}
                                ></div>
                              </div>
                            )}
                          </TabPane>
                        ))}
                    </div>
                  )}
                </div>
              </div>
            ) : null}

            {/* Show awards and insights sections only for team members (i.e. Portfolio Management department) */}

            {bio.department === "Portfolio Management" ? (
              <>
                {bio.award && bio.award.length > 0 ? (
                  <div className="pb-5">
                    <h2 className="small-section-heading mb-5">
                      Awards &amp; Recognition
                    </h2>
                    <div className="bio-awards-swiper-wrapper">
                      <div className="bio-awards-swiper-navigation">
                        <div
                          id="bio-awards-prev"
                          role="button"
                          aria-label="Previous"
                        ></div>
                        <div
                          id="bio-awards-next"
                          role="button"
                          aria-label="Next"
                        ></div>
                      </div>
                      <div className="row justify-content-center">
                        <div className="col-9 col-md-10">
                          <Swiper
                            modules={[Pagination, Navigation]}
                            slidesPerView={5}
                            spaceBetween={30}
                            speed={700}
                            autoplay={{
                              delay: 1000,
                              disableOnInteraction: false,
                            }}
                            pagination={{
                              el: ".swiper-pagination",
                              type: "bullets",
                              clickable: true,
                            }}
                            navigation={{
                              nextEl: "#bio-awards-next",
                              prevEl: "#bio-awards-prev",
                            }}
                            breakpoints={{
                              1024: {
                                slidesPerView: 4,
                                spaceBetween: 10,
                              },
                              768: {
                                slidesPerView: 3,
                                spaceBetween: 10,
                              },
                              640: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                              },
                              320: {
                                slidesPerView: 1,
                                spaceBetween: 0,
                              },
                            }}
                          >
                            {bio.award.map((icons, index) => (
                              <div key={index}>
                                <GatsbyImage
                                  image={icons.icon.asset.gatsbyImageData}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                            ))}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="pb-5">
                  <h2 className="small-section-heading">What We’re Thinking</h2>
                  <div className="row g-5">
                    {posts.map((article, idx) => (
                      <div className="col-lg-6 col-xl-4">
                        <ArticleLeft
                          key={idx}
                          idx={article.idx}
                          link={article.slug.current}
                          banner={
                            article?.mainImage !== null
                              ? getSrc(
                                  article?.mainImage?.asset?.gatsbyImageData
                                )
                              : placeholder
                          }
                          categories={
                            article.categories.length
                              ? article.categories
                              : null
                          }
                          title={article.title}
                          excerpt={
                            article.excerpt
                              ? article.excerpt.length > 70
                                ? `${article.excerpt.substring(0, 70)}...`
                                : article.excerpt
                              : article.videoUrl
                              ? article.videoUrl
                              : null
                          }
                          authorImage={
                            getSrc(
                              article?.authors?.image?.asset?.gatsbyImageData
                            )
                              ? getSrc(
                                  article?.authors?.image?.asset
                                    ?.gatsbyImageData
                                )
                              : null
                          }
                          author={article.authors.name}
                          publishedAt={article.publishedAt}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : null}
            <div className="text-center d-flex flex-wrap justify-content-center gap-2">              
              <Link className="solid-btn-homepage" to="/our-team">
                Explore all profiles
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default BioTemplate

export const bioQuery = graphql`
  query bioTemplateQuery($title: String!) {
    sanityPerson(name: { eq: $title }) {
      id
      metaDesc
      metaKeyword
      metaTitle
      name
      nickname
      position
      languages
      appointmentLink
      linkedinLink
      department
      headerBackground {
        asset {
          gatsbyImageData
        }
      }
      image {
        asset {
          gatsbyImageData
        }
      }
      award {
        icon {
          asset {
            gatsbyImageData(width: 200)
          }
        }
      }
      biography {
        body
        language
        quotation
      }
      galleryList {
        asset {
          gatsbyImageData(width: 800)
        }
      }
    }
    allSanityPost(
      sort: { fields: publishedAt, order: DESC }
      limit: 3
      filter: { language: { eq: "en" } }
    ) {
      edges {
        node {
          id
          title
          language
          slug {
            current
          }
          featured
          mainImage {
            asset {
              gatsbyImageData
            }
            alt
          }
          publishedAt(formatString: "MMMM DD, YYYY")
          excerpt
          videoUrl
          categories {
            id
            title
          }
          authors {
            name
            image {
              asset {
                gatsbyImageData(width: 50, height: 50)
              }
            }
          }
        }
      }
    }
  }
`
